import { downloadTaskBulkTemplate, uploadTaskBulkExcel } from './api/taskApi'
import SharedBulkUploadScreen from '../../../components/SharedBulkUploadScreen'

const TASK_TEMPLATES = [
  {
    key: 'task_standard',
    icon: 'task_alt',
    color: '#1E3A8A',
    badge: 'Standard',
    title: 'Standard Task Template',
    subtitle: 'Create tasks across projects with assignees & timelines',
    description:
      'Use this template to import multiple tasks linked to existing projects. Specify Task Name, Project Code/Name, Assignee Email, Start Date, Due Date, Priority, and Estimated Hours.',
    columns: [
      'Project Code / Name *',
      'Task Name *',
      'Description',
      'Assignee Email / Name',
      'Priority (LOW/MEDIUM/HIGH)',
      'Start Date * (YYYY-MM-DD)',
      'Due Date * (YYYY-MM-DD)',
      'Effort Estimate (Hours)',
      'Notes',
    ],
    fileName: 'Task_Bulk_Upload_Template.xlsx',
    downloadFn: () => downloadTaskBulkTemplate(),
  },
]

export default function TaskBulkUploadScreen() {
  return (
    <SharedBulkUploadScreen
      eyebrow="Operational Console"
      title="Bulk Task Upload"
      subtitle="Import multiple tasks at once across your projects using the standardized Excel template."
      returnUrl="/nerve/task/list"
      templates={TASK_TEMPLATES}
      uploadFn={uploadTaskBulkExcel}
      entityLabelSingular="task"
      entityLabelPlural="tasks"
    />
  )
}
